import { render, staticRenderFns } from "./IndicatorTable.vue?vue&type=template&id=0b49d09f&scoped=true"
import script from "./IndicatorTable.vue?vue&type=script&lang=js"
export * from "./IndicatorTable.vue?vue&type=script&lang=js"
import style0 from "./IndicatorTable.vue?vue&type=style&index=0&id=0b49d09f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b49d09f",
  null
  
)

export default component.exports